$(document).ready(function(){
    $("#HeaderMenu-about").on('click', function(event) {
    event.preventDefault();
    var hash = this.hash;
    var offset = $(window).width() < 768 ? 50 : 100;
       $('html, body').animate({
            scrollTop: $(hash).offset().top - offset
        }, 1200);
  });

  
});